// Note: the values in this enum are shown to the user
export enum MethodEditorTab {
  DEFINITIONS = 'Definitions',
  STEP_CONFIG = 'Steps',
  ANALYSIS_TEMPLATE_CONFIG = 'Data & analysis',
  TESTS = 'Tests',
  METADATA = 'Metadata',
}
